module.exports = __webpack_public_path__ + "img/ex09.b02b3146.png";